// tslint:disable
export var IContractStatus;

(function (IContractStatus) {
  IContractStatus["SETUP"] = "SETUP";
  IContractStatus["ACTIVE"] = "ACTIVE";
  IContractStatus["CLOSED"] = "CLOSED";
})(IContractStatus || (IContractStatus = {}));